import createMonthViewContext from './context-adaptor';

export default createMonthViewContext;
